/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AgentContextQuery } from '@atlassian/agent-context/entrypoint/AgentContextQuery.graphql';
import parameters from '@atlassian/agent-context/entrypoint/AgentContextQuery$parameters';

type AgentContextEntryPointComponent = EntryPointComponent<
	{ agentContextQuery: AgentContextQuery },
	{},
	{},
	{}
>;

export const AgentContextEntryPoint: EntryPoint<
	AgentContextEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<AgentContextEntryPointComponent>(
		/* webpackChunkName: "async-agent-context-app" */ './AgentContextApp.tsx',
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey ?? '';

		return {
			queries: {
				agentContextQuery: {
					options: { fetchPolicy: 'network-only' as const },
					parameters,
					variables: {
						cloudId,
						input: {
							projectByKey: { cloudId, projectKey },
						},
						first: 50,
						after: null,
						filter: null,
						isNewAgentContext: fg('jira_agent_context_new_ui'),
					},
				},
			},
		};
	},
});
